import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Navbar.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext'; 

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { lang, setLang, t } = useLanguage(); 
  const navigate = useNavigate();
  const location = useLocation();

  // Kanka, şu an translations.js'de TR, EN ve AR tam hazır. Diğerlerini de zamanla ekleriz.
  const languages = ['TR', 'EN', 'AR'];

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        window.scrollTo({ top: element.offsetTop - 80, behavior: 'smooth' });
      }
    }
    setIsOpen(false);
  };

  return (
    /* Kanka, LanguageContext sayesinde lang === 'AR' olduğunda sayfa dir="rtl" oluyor */
    <nav className={`navbar-main-container ${lang === 'AR' ? 'rtl-nav' : ''}`}>
      <div className="navbar-wrapper">
        
        <div className="logo-brand-section">
          <Link to="/" className="brand-link">
            <div className="brand-text-icon">B</div>
            <div className="brand-text">
              <span className="brand-name">BIGMA GRUP</span>
              <span className="brand-subtext">BIOTECHNOLOGIES A.Ş.</span>
            </div>
          </Link>
        </div>

        {/* Masaüstü Menü - t() fonksiyonu translations.js'den Arapçaları çeker */}
        <div className="desktop-nav-links">
          <Link to="/" className="nav-item active-green">
            {t('navbar.home')}
          </Link>

          <a 
            href="#hakkimizda-bolumu" 
            className="nav-item" 
            onClick={(e) => handleScroll(e, 'hakkimizda-bolumu')}
          >
            {t('navbar.about')}
          </a>

          <Link to="/urunlerimiz" className="nav-item">
            {t('navbar.products')}
          </Link>
          
          <a 
            href="#teknik-foyler" 
            className="nav-item" 
            onClick={(e) => handleScroll(e, 'teknik-foyler')}
          >
            {t('navbar.tech')}
          </a>
          <a 
            href="#blog" 
            className="nav-item" 
            onClick={(e) => handleScroll(e, 'blog')}
          >
            {t('navbar.blog')}
          </a>
          
          <Link to="/iletisim" className="nav-item">
            {t('navbar.contact')}
          </Link>
        </div>

        <div className="nav-right-actions">
          <div className="lang-switcher">
            {languages.map((l) => (
              <button 
                key={l} 
                className={`lang-btn ${lang === l ? 'active-lang' : ''}`}
                onClick={() => setLang(l)} 
              >
                {l}
              </button>
            ))}
          </div>

          <div className="mobile-toggle" onClick={toggleMenu}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </div>
        </div>
      </div>

      {/* Mobil Menü Paneli */}
      <div className={`mobile-menu-overlay ${isOpen ? 'show' : ''}`}>
        <div className="mobile-menu-content">
          <Link to="/" onClick={toggleMenu}>{t('navbar.home')}</Link>
          
          <a href="#hakkimizda-bolumu" onClick={(e) => handleScroll(e, 'hakkimizda-bolumu')}>
            {t('navbar.about')}
          </a>

          <Link to="/urunlerimiz" onClick={toggleMenu}>{t('navbar.products')}</Link>
          
          <a href="#teknik-foyler" onClick={(e) => handleScroll(e, 'teknik-foyler')}>
            {t('navbar.tech')}
          </a>
          <a href="#blog" onClick={(e) => handleScroll(e, 'blog')}>
            {t('navbar.blog')}
          </a>
          
          <Link to="/iletisim" onClick={toggleMenu}>{t('navbar.contact')}</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;